const baseURL = ''
const DEFAULT_RDV_HOUR = 30 // minutes;

export {
    baseURL,
    DEFAULT_RDV_HOUR
}
